import { getData, postData, putData } from './redux_data';
import {
    GET_USUARIOS, GET_USUARIOS_KD, GET_USUARIO_DETALLES, UPDATE_USUARIO_DETALLES, ADD_NEW_USUARIO, MODIFY_USUARIO_DETALLES
} from '../constants/action_types';

export function getUsuarios() {
    return getData('vusuarios', GET_USUARIOS);
}

export function getUsuariosKD(id) {
    return getData('vusuarios/kd?centro=' + id, GET_USUARIOS_KD);
}

export function getUsuarioDetalle(id) {
    return getData('usuarios/' + id, GET_USUARIO_DETALLES);
};

export function modifyFieldDetalleUsuario(field, value) {
    return dispatch => {
        dispatch({ type: MODIFY_USUARIO_DETALLES, payload: { field, value } })
    };
};

export function newUsuarioDB(usuario, thenHandler) {
    return postData('usuarios', UPDATE_USUARIO_DETALLES, usuario, 'Usuario creado correctamente', thenHandler);
}

export function updateDetallesUsuarioDB(usuario, id, thenHandler) {
    return putData('usuarios', UPDATE_USUARIO_DETALLES, usuario, id, 'usuario modificado correctamente', thenHandler);
}

export function addNewUsuario(defaultCenter) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_NEW_USUARIO, payload:{defaultCenter} });
    };
};
